// Minimal debug helpers for mix engine. Enable with:
// - localStorage.setItem('mixdbg','1')  OR  add "?mixdbg=1" to URL
// - (optionally) window.__MIXDBG = true
//
// View events: window.__mixEvents
// Dump quickly: copy(JSON.stringify(window.__mixEvents, null, 2))

export type MixEvent = {
  tsPerf: number;       // performance.now()
  tsCtx: number;        // AudioContext.currentTime (if provided)
  tag: string;          // e.g. 'sched.begin', 'stem.start'
  data: any;            // arbitrary payload
};

const MAX_EVENTS = 1000;

export function dbgEnabled(): boolean {
  try {
    const w = window as any;
    if (w.__MIXDBG === true) return true;
    if (localStorage.getItem('mixdbg') === '1') return true;
    // Use explicit window reference to satisfy no-restricted-globals
    if (typeof window !== 'undefined' && typeof window.location?.search === 'string' && /\bmixdbg=1\b/.test(window.location.search)) return true;
  } catch {}
  return false;
}

export function ev(tag: string, data: any, ctx?: BaseAudioContext | null) {
  if (!dbgEnabled()) return;
  const e: MixEvent = {
    tsPerf: (typeof performance !== 'undefined' ? performance.now() : Date.now()),
    tsCtx: (ctx as any)?.currentTime ?? NaN,
    tag,
    data,
  };
  try {
    const w = window as any;
    const store: MixEvent[] = (w.__mixEvents = w.__mixEvents || []);
    store.push(e);
    if (store.length > MAX_EVENTS) store.splice(0, store.length - MAX_EVENTS);
  // Optional console trace: enable via localStorage.setItem('MIX_TRACE','1')
  try { if (localStorage.getItem('MIX_TRACE') === '1') { /* eslint-disable no-console */ console.log('[mix]', tag, e); /* eslint-enable no-console */ } } catch {}
  } catch {}
}

export function nextId(prefix = 'sched'): string {
  try {
    const w = window as any;
    w.__mixSeq = (w.__mixSeq || 0) + 1;
    return `${prefix}:${w.__mixSeq}`;
  } catch {
    return `${prefix}:${Math.random().toString(36).slice(2, 8)}`;
  }
}
